import React from 'react';
import Select from '@app/ui/sports-components/Select';

const options = [
    { value: '', name: 'Show All' },
    { value: true, name: 'Active' },
    { value: false, name: 'Inactive' },
];

const filterMethod = (filter, row) =>
    !filter.value || row[filter.id].toString() === filter.value;

const Filter = ({ onChange }: { onChange: (value: string) => void }) => {
    const handleChange = event => {
        onChange(event.target.value);
    };

    return (
        <Select
            size="sm"
            options={options}
            onChange={handleChange}
            customValue="value"
        />
    );
};

const StatusFilter = { Filter, filterMethod };
export default StatusFilter;
